import SellDomainDashboard from '../SellDomainDashboard';

const SellDomainPanel = () => {
  return (
    <div>
      <SellDomainDashboard />
    </div>
  );
};

export default SellDomainPanel;
